/**
 * Event functions
 */
import { createRPCError } from './rpc-error';
/**
 * create an event object
 */
export function createEvent(type, payload, givenUid) {
    return {
        payload,
        type,
        uid: givenUid,
    };
}
/**
 * create an error event object
 */
export function createErrorEvent(c, type, error, id) {
    return createEvent(type, { error: createRPCError(c, error) }, id);
}
//# sourceMappingURL=events.js.map